import { useState } from "react";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { CashFlow, MesCashFlow } from "@/lib/api";

/**
 * Lógica del cash flow mensual (sin JSX, sólo admin): la tabla por mes que arma el backend (comprometido y estimado,
 * cada uno en materiales y mano de obra, fee, total y acumulado), un mes abierto por rubro, lo que va sin fecha y los
 * ítems sin presupuesto asignado.
 */
export function useCashFlowTab() {
  const { fid } = useContextoApp();
  const recurso = useApiResource<CashFlow>(`/api/fideicomisos/${fid}/cash-flow`);
  const [abierto, setAbierto] = useState<string | null>(null);
  const cf = recurso.data ?? null;

  return {
    cashFlow: cf,
    cargando: recurso.loading && !cf,
    error: cf ? null : (recurso.error?.message ?? null),
    /** El mes que se ve por rubro (tocar de nuevo lo cierra). */
    mesAbierto: cf?.meses.find((m) => m.mes === abierto) ?? null,
    alternarMes: (m: MesCashFlow) => setAbierto((actual) => (actual === m.mes ? null : m.mes)),
    cerrarMes: () => setAbierto(null),
  };
}
